import { Component, OnInit, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Select } from "primeng/select";
import { ICellRendererParams } from 'ag-grid-community';
import { EmissionsFactoryForFormModel } from '@features/emissions/models/emissions-factory.model';
import { FactorSelectCountry } from "../factor-select-country/factor-select-country";

interface FactorsMap {
  [key: string]: string;
}

@Component({
  selector: 'app-factor-select',
  imports: [
    Select, 
    FactorSelectCountry, 
    FormsModule, 
    ReactiveFormsModule
  ],
  templateUrl: './factor-select.html',
  styleUrl: './factor-select.scss',
})
export class FactorSelect implements ICellRendererAngularComp, OnInit {
  private readonly http = inject(HttpClient);
  
  public selectedValue: string | null = null;
  factorOptions: EmissionsFactoryForFormModel[] = [];
  private params!: ICellRendererParams;
  factorsMap: FactorsMap | null = null;

  ngOnInit(): void {
    this.loadFactorsMap();
  }

  /**
   * Carga el diccionario factors.json
   */
  private loadFactorsMap(): void {
    this.http.get<FactorsMap>('assets/data/factors.json').subscribe({
      next: (map) => {
        this.factorsMap = map;
      },
      error: () => {
        // Fallback: continuar sin diccionario
        this.factorsMap = {};
      }
    });
  }

  /**
   * Obtiene el código traducido del diccionario o retorna el código original
   */
  getTranslatedCode(code: string): string {
    if (!this.factorsMap || !code) return code;
    return this.factorsMap[code] || code;
  }

  // agInit es llamado por AG Grid antes del llamado a ngOnInit
  agInit(params: ICellRendererParams & { options: EmissionsFactoryForFormModel[] }): void {
    this.params = params;
    // Setear valores para los options y factores seleccionados
    this.factorOptions = params.options || [];
    this.selectedValue = params.value; 
  }

  refresh(params: ICellRendererParams): boolean {
    // Si la celda se refresca desde afuera, actualizamos el valor local
    this.params = params;
    this.selectedValue = params.value;
    return true;
  }

  // Método para manejar el cambio en el select
  onChange(event: any): void {
    const newValue = event.value;
    
    // Recalcular fórmulas de ResultDefinition
    if (this.params.node && this.params.colDef?.field) {
        this.params.node.setDataValue(this.params.colDef.field, newValue);
    }
  }
}